import { apiService } from 'core/services/apiService';
import { UserAvailability } from 'core/interfaces/userInterface';

export const USER_AVAILABILITIES_COLLECTION = 'user_availabilities';

export interface UserAvailabilityPayload {
	workplace: string;
	startAt: string;
	endAt: string;
	day: string;
}

export const getUserAvailabilityItemEndpoint = (id: number | string): string =>
	`${USER_AVAILABILITIES_COLLECTION}/${id}`;

export const createUserAvailability = async (
	data: UserAvailabilityPayload,
): Promise<UserAvailability> => {
	const response = await apiService.post(USER_AVAILABILITIES_COLLECTION, data);
	return apiService.responseHandler(response);
};

export const updateUserAvailability = async (
	id: number | string,
	data: UserAvailabilityPayload,
): Promise<UserAvailability> => {
	const response = await apiService.patch(getUserAvailabilityItemEndpoint(id), data);
	return apiService.responseHandler(response);
};

export const deleteUserAvailability = async (id: number | string): Promise<void> => {
	await apiService.delete(getUserAvailabilityItemEndpoint(id));
};
